import { MoreHoriz } from '@mui/icons-material';
import type { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { OutlinedIconButton } from '~/components/button';

export interface ActionsProps {
  onShowMenu?: MouseEventHandler<HTMLButtonElement>;
}

export const Actions = ({ onShowMenu }: ActionsProps) => {
  const { t } = useTranslation();

  return (
    <OutlinedIconButton label={t('common.buttons.more_actions')} onClick={onShowMenu} size="large">
      <MoreHoriz />
    </OutlinedIconButton>
  );
};
